import axios from "../utils/axios";

export function fetchUser(user: string, token: string ) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_API_DOMAIN}/users/${user}/`, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function putUserInformation(userId: string, token: string, payload: any) {
  return new Promise((resolve, reject) => {
      axios
          .patch(`${process.env.REACT_APP_API_DOMAIN}/users/${userId}/`,payload, {
              headers: {
                  Authorization: "Token " + token,
              },
          })
          .then((response) => {
              if (response.status === 200) {
                  resolve(response);
              }
              reject(response.data);
          })
          .catch((error) => {
              reject(error);
          });
  });
}
